module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/hero-mobile-fr-5174e52cc6d1af40439dd180f632cb94.png";